<template>
  <v-dialog v-model="dialog" max-width="300">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" text rounded @click.stop="dialog = true"><v-icon>mdi-download</v-icon>&nbsp;Download</v-btn>
    </template>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2"> File Download </v-card-title>

      <v-card-text class="pt-3" v-html="html"> </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="
            dialog = false;
            $emit('confirmed');
          "
        >
          Ja
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    downloadFileTitle: String,
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    html() {
      return `Wollen Sie <b>${this.downloadFileTitle}</b> downloaden?<br><br>Sie werden das File anschliessend in den Downloads Ihres Gerätes finden.`;
    },
  },
};
</script>

<style></style>
